import { Icon } from '@iconify/react'
import type { SplitFormItem, SplitFormType } from './split-form'
import styles from './SplitsGlobaisPage.module.css'

type SplitFormRowsProps = {
  splits: SplitFormItem[]
  idPrefix: string
  onChange: (id: string, patch: Partial<Omit<SplitFormItem, 'id'>>) => void
  onRemove: (id: string) => void
}

export function SplitFormRows({ splits, idPrefix, onChange, onRemove }: SplitFormRowsProps) {
  return (
    <div className={styles.splitsList}>
      <div className={styles.splitsRowHeader}>
        <span className={styles.splitsColNome}>Nome</span>
        <span className={styles.splitsColId}>ID Doey</span>
        <span className={styles.splitsColTipo}>Tipo</span>
        <span className={styles.splitsColValor}>Valor</span>
        <span className={styles.splitsColAction} aria-hidden />
      </div>
      {splits.map((split) => (
        <div key={split.id} className={styles.splitsRow}>
          <div className={`${styles.field} ${styles.splitsColNome}`}>
            <label htmlFor={`${idPrefix}-nome-${split.id}`} className={styles.srOnly}>
              Nome
            </label>
            <input
              id={`${idPrefix}-nome-${split.id}`}
              type="text"
              className={styles.input}
              placeholder="Nome"
              value={split.nome}
              onChange={(event) => onChange(split.id, { nome: event.target.value })}
            />
          </div>
          <div className={`${styles.field} ${styles.splitsColId}`}>
            <label htmlFor={`${idPrefix}-doey-${split.id}`} className={styles.srOnly}>
              ID Doey
            </label>
            <input
              id={`${idPrefix}-doey-${split.id}`}
              type="text"
              className={styles.input}
              placeholder="ID Doey"
              value={split.doeyId}
              onChange={(event) => onChange(split.id, { doeyId: event.target.value })}
            />
          </div>
          <div className={`${styles.field} ${styles.splitsColTipo}`}>
            <label htmlFor={`${idPrefix}-tipo-${split.id}`} className={styles.srOnly}>
              Tipo
            </label>
            <select
              id={`${idPrefix}-tipo-${split.id}`}
              className={styles.input}
              value={split.tipo}
              onChange={(event) => {
                const tipo = event.target.value as SplitFormType
                onChange(split.id, {
                  tipo,
                  porcentagem: tipo === 'percentage' ? split.porcentagem : '',
                  valorFixo: tipo === 'fixed' ? split.valorFixo : '',
                })
              }}
            >
              <option value="percentage">Porcentagem</option>
              <option value="fixed">Valor fixo</option>
            </select>
          </div>
          <div className={`${styles.field} ${styles.splitsColValor}`}>
            {split.tipo === 'fixed' ? (
              <>
                <label htmlFor={`${idPrefix}-valor-${split.id}`} className={styles.srOnly}>
                  Valor fixo
                </label>
                <input
                  id={`${idPrefix}-valor-${split.id}`}
                  type="number"
                  min={0.01}
                  step={0.01}
                  className={styles.input}
                  placeholder="R$"
                  value={split.valorFixo}
                  onChange={(event) => onChange(split.id, { valorFixo: event.target.value })}
                />
              </>
            ) : (
              <>
                <label htmlFor={`${idPrefix}-pct-${split.id}`} className={styles.srOnly}>
                  Porcentagem
                </label>
                <input
                  id={`${idPrefix}-pct-${split.id}`}
                  type="number"
                  min={0}
                  max={100}
                  step={0.01}
                  className={styles.input}
                  placeholder="%"
                  value={split.porcentagem}
                  onChange={(event) => onChange(split.id, { porcentagem: event.target.value })}
                />
              </>
            )}
          </div>
          <div className={styles.splitsColAction}>
            <button
              type="button"
              className={styles.removeSplitBtn}
              onClick={() => onRemove(split.id)}
              aria-label="Remover split"
              title="Remover split"
            >
              <Icon icon="mdi:trash-can-outline" width={20} height={20} />
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}
